<table class="table">
  <thead>
    <tr>
      <th>Descrição</th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="anotacao in anotacoes track by $index"
        ng-mouseleave="resetAnimationMarker(anotacao.marker.marker, $index)"
        ng-mouseover="setAnimationMarker(anotacao.marker.marker, $index)"
        ng-click="openInfoWindow(anotacao.marker.marker, $index)"
        ng-class="{'activate-line': anotacao.marker.leafletMarker.isPopupOpen()}"
        class="pointer">
      <td>{{anotacao.descricao}}</td>
    </tr>
  </tbody>
</table>
